<mat-tree [dataSource]="dataSource" #momTree [treeControl]="treeControl" class="example-tree" >
  <mat-tree-node style="color: #0d6efd !important;margin-top: -14px; display: flex; align-items: flex-start;"
    *matTreeNodeDef="let node;"   id="level{{node.id}}" matTreeNodeToggle >
    <li class="mat-tree-node">  
      <button *ngIf="node.type=='AI' || node.type=='MN' || node.type=='MD'" class="mat-margin-3px global-icn-bttn-normal-container" color = "primary" mat-mini-fab color = "primary" tooltip = "{{node.createdByName}}" placement = "right" triggers = "hover">{{node.shortName}}</button>
      <button mat-icon-button (click)="checking(node.level)" disabled>
        <mat-icon tooltip = "{{node.icon == 'notes' ? 'Note' : node.icon == 'assignment' ? 'Task' : node.icon == 'thumb_up' ? 'Decision' : ''}}" placement = "left" triggers = "hover" class="global-icn-size" [ngStyle]="node.icon == 'notes' ? {'color': 'var(--bttn-secondary)','margin-right': '5px','margin-top': '-2px'} : node.icon == 'assignment' ? {'color': 'var(--bttn-green)','margin-right': '5px','margin-top': '-2px'} : node.icon =='thumb_up' ? {'color': 'var(--bttn-orange)','margin-right': '5px','margin-top': '-2px'} : {'color': 'black','margin-right': '5px','margin-top': '-2px'}">{{node.icon}}
        </mat-icon> 
      </button> 
      <button mat-icon-button *ngIf="node.type=='AI'" (click)="taskEditDialog(node)">
        <mat-icon tooltip="Edit" placement = "left" triggers = "hover" >edit</mat-icon>
      </button>
      <div>
      <!-- <mat-checkbox style="position: relative;top: -8px;" class="checklist-leaf-node" (change)="taskCheckValue($event,node);todoItemSelectionToggle($event.checked,node);" 
        [checked]="node.selected">
        </mat-checkbox>{{node.name}} -->
        <span (click)="logNode(node);" [innerHTML]="node.name"></span>
      </div>
    </li>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li>
      <div class="mat-tree-node">
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" [attr.aria-expandable]="true">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
       <div>
        <!-- <mat-checkbox style="position: relative;top: -8px;" [checked]="node.selected" [indeterminate]="node.indeterminate && !node.selected"
          (change)="taskCheckValue($event,node);todoItemSelectionToggle($event.checked,node);">{{node.name}}
        </mat-checkbox> -->
        <span (click)="logNode(node);" [innerHTML]="node.name"></span>
      </div>
      </div>
      <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
<div>
  <div class="loading-indicator" style="display: inline-flex;">
    <mat-progress-spinner mode="indeterminate" *ngIf="showLoading" 
bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
  </div>
<div *ngIf="ShowMoreIcon && showLoading==false"><button (click)="initialize(meetingId)" 
class="button-container start" 
mat-raised-button><mat-icon>expand_more</mat-icon>more</button></div>
</div>
